var map = {
	"./admin.png": 7455,
	"./avatar.png": 4367,
	"./bg-404.png": 5962,
	"./bg-login-new.jpg": 7552,
	"./bg-maintenance.png": 1407,
	"./bg_Login_Elok2.png": 2607,
	"./bg_login.jpg": 7467,
	"./icn-map-lokasi.png": 4471,
	"./icn-map-loket.png": 3871,
	"./icn-map-organisasi.png": 9056,
	"./icn_profildesa.png": 8138,
	"./logo-elok-new.png": 8404,
	"./logo-elok-persegi.png": 7419,
	"./logo-elok-putih.png": 2626,
	"./logo-elok-warna.png": 9620,
	"./logo-elok-white.png": 3538,
	"./logo-elok.png": 9417,
	"./logo.png": 5549,
	"./loket.png": 5791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;